import { api } from '../api';
import type { Group } from '../types';

export const createGroup = (name: string, currency: string, userId: string) => api.groups.create(name, currency, userId);
export const joinGroup = (groupId: string, userId: string) => api.groups.join(groupId, userId);
export const getUserGroups = (userId: string) => api.groups.getUserGroups(userId);
export const getGroupById = (groupId: string) => api.groups.getById(groupId);
export const subscribeToGroup = (groupId: string, callback: (group: Group | null) => void) => api.groups.subscribe(groupId, callback);
export const generateGroupCode = () => Math.random().toString(36).substring(2, 8).toUpperCase();
